import Vue from "vue";
import VueRouter from "vue-router";
import AuthForm from "@/components/forms/AuthForm";
import PersonalForm from "@/components/forms/PersonalForm";
import DetailsForm from "@/components/forms/DetailsForm";
import BasicForm from "@/components/forms/BasicForm";
import ContactTaxForm from "@/components/forms/ContactTaxForm";
import InvestmentForm from "@/components/forms/InvestmentForm";
import BankForm from "@/components/forms/BankForm";
import AgreementForm from "@/components/forms/AgreementForm";
import ReviewForm from "@/components/forms/ReviewForm";
import {store} from "@/store";
import CompletedForm from "@/components/forms/CompletedForm";
import AlreadyCompletedForm from "@/components/forms/AlreadyCompletedForm";
import KYCForm from "@/components/forms/KYCForm";

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        component: AuthForm
    },
    {
        path: '/personal',
        component: PersonalForm
    },
    {
        path: '/details',
        component: DetailsForm,
        children: [
            {
                path: '',
                component: BasicForm,
            },
            {
                path: 'contact-tax-reporting',
                component: ContactTaxForm,
            },
            {
                path: 'kyc',
                component: KYCForm,
            },
            {
                path: 'investment-plan',
                component: InvestmentForm,
            },
            {
                path: 'bank-account',
                component: BankForm,
            },
            {
                path: 'agreements',
                component: AgreementForm,
            },
        ],
    },
    {
        path: '/review',
        component: ReviewForm,
    },
    // {
    //     path: '/subscription-agreement',
    //     component: SubscriptionAgreement,
    // },
    {
        path: '/completed',
        component: CompletedForm,
    },
    {
        path: '/already-completed',
        component: AlreadyCompletedForm,
    },
    {
        path: '/auth',
        component: AuthForm,
        meta: {
            requireAuth: false,
            requireGuest: false,
        },
        props: (route) => ({ preAuthenticate: route.query.t }),
    },
    {
        path: '/sign-out',
        name: 'Sign Out',
        component: function () {
            store.commit("logoutUser");
            store.commit("resetAll");
            router.replace("/");
        },
        meta: {
            requireAuth: true,
            requireGuest: false,
        },
    },
]

export const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior() {
        return { x: 0, y: 0 };
    }
})